module.exports = "static/assets/52d442dc8e71307ec251603d1edd35f0.mp3";